<template>
    <div class="login__error login__error_theme_available">
        <div class="login__error-icon">
            <IconRepairBig />
        </div>

        <h3 class="login__error-title">
            {{ errorTitle }}
        </h3>

        <div
            class="login__error-text"
            v-html="errorText" />

        <div class="login__error-button">
            <STBaseButton
                text="Попробовать снова"
                modify="button_full_width"
                @click="checkAvailableAuth" />
        </div>
    </div>
</template>

<script>
import IconRepairBig from '@/components/Icons/RepairBig';

export default {
    name: 'AvailableError',

    components: {
        IconRepairBig
    },

    props: {
        errorTitle: {
            type    : String,
            required: true
        },
        errorText: {
            type    : String,
            required: true
        }
    },

    methods: {
        checkAvailableAuth() {
            this.$emit('checkAvailableAuth');
        }
    }
};
</script>
